import logEvent from 'analytics/logEvent';
import Cookies from 'js-cookie';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/basic/Button';
import { BodyM } from 'components/domains/typography/Typography';

import type { AppState } from 'redux-store';

import styles from './styles.module.scss';

export const GetApp: React.FC = () => {
  const userAgent = useSelector((state: AppState) => state.ui.userAgent);
  const isMobile = userAgent.device.type === 'mobile';
  const isIOS = userAgent.os.name === 'iOS';
  const [isGetAppShowing, setGetAppShowing] = useState(false);
  const [bottom, setBottom] = useState(5);
  const router = useRouter();

  useEffect(() => {
    const cookieAccept = Cookies.get('WELLTORY_GET_APP_CLOSED');

    if (cookieAccept) {
      return;
    }

    const observer = new MutationObserver(
      (mutationsList: MutationRecord[], observe: MutationObserver) => {
        for (const mutation of mutationsList) {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                (node as Element).matches('.CookieBanner')
              ) {
                if (node) {
                  // @ts-ignore
                  const rect = node.getBoundingClientRect();
                  // logEvent('Web_Popup_Viewed');

                  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                  setBottom(rect.height + 5);
                }
              }
            });
          }

          if (mutation.removedNodes.length) {
            mutation.removedNodes.forEach(node => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                (node as Element).matches('.CookieBanner')
              ) {
                setBottom(5);
                // Вы можете остановить наблюдение после обнаружения удаления элемента, если хотите
                observe.disconnect();
              }
            });
          }
        }
      },
    );

    observer.observe(document.body, { childList: true, subtree: true });
    setGetAppShowing(true);
  }, []);

  function onClose(): void {
    Cookies.set('WELLTORY_GET_APP_CLOSED', '1');
    logEvent('Web_Popup_Close_Button_Clicked');
    setGetAppShowing(false);
  }

  if (!isGetAppShowing || !router.pathname.startsWith('/devices')) {
    return null;
  }

  return (
    <div className={styles.container} style={{ bottom }}>
      <div className={styles.cross} onClick={onClose}>
        <Image
          src="/pagesImages/common/GetApp/cross.svg"
          width={24}
          height={24}
          alt="close"
        />
      </div>
      <div className={styles.top}>
        <div className={styles.heart}>
          <Image
            src="/pagesImages/common/GetApp/welltory_heart.svg"
            layout="fill"
            alt="welltory logo"
          />
        </div>
        <div className={styles.content}>
          <BodyM className={styles.text}>
            Welltory is the Ultimate HRV App
          </BodyM>
        </div>
      </div>
      <div className={styles.middle}>
        {!isMobile ? (
          <div className={styles.link}>
            <Button
              size="medium"
              className={styles.button}
              href="https://app.welltory.com/payments/plans/blog/?coupon=blog35_wp"
              onClick={(): void => {
                logEvent('Web_Popup_Store_Button_Clicked', {
                  type: isIOS ? 'appstore' : 'googleplay',
                });
              }}
            >
              35% OFF Premium
            </Button>
          </div>
        ) : null}
        <div className={styles.image}>
          <Image
            width={78}
            height={51}
            src="/pagesImages/common/GetApp/downloads.png"
          />
        </div>
        <div className={styles.image}>
          <Image
            width={61}
            height={51}
            src="/pagesImages/common/GetApp/ratings.png"
          />
        </div>
        <div className={styles.image}>
          <Image
            width={89}
            height={51}
            src="/pagesImages/common/GetApp/reviews.png"
          />
        </div>
        {!isMobile ? (
          <div className={styles.qr}>
            <Image
              src="/pagesImages/common/GetApp/qr_code.png"
              width={64}
              height={64}
            />
          </div>
        ) : null}
      </div>
      {isMobile ? (
        <div className={styles.bottom}>
          <div className={styles.link}>
            <Button
              size="medium"
              className={styles.button}
              href="https://app.welltory.com/payments/plans/blog/?coupon=blog35_wp"
              onClick={(): void => {
                logEvent('Web_Popup_Store_Button_Clicked', {
                  type: isIOS ? 'appstore' : 'googleplay',
                });
              }}
            >
              Get Welltory Premium with 35% OFF
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};
